import React, { useState, useEffect } from 'react'
import { Table, IconButton, Icon, Row, Col, Input } from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import SearchButton from '../../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import { budgetFormat } from '../../../utils/formatterUtil'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'

export default function SubProjectProjectTable({
  schema,
  loading,
  onSearch = () => {},
  onSelect = () => {},
  isLoading,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)

  const [tableData, setTableData] = useState([])
  const [totalSize, setTotalSize] = useState(0)

  const [subProjectCode, setSubProjectCode] = useState('')
  const [subProjectName, setSubProjectName] = useState('')

  useEffect(() => {
    setTableData(schema?.data?.values || [])

    setTotalSize(schema?.data?.totalSize || 0)
  }, [schema])

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  const createRequest = () => {
    return {
      subProjectCode: subProjectCode,
      subProjectName: subProjectName,
    }
  }

  const handleChangePage = (dataKey) => {
    console.log('handleChangePage ', dataKey)

    const request = createRequest()

    setPage(dataKey)
    onSearch(request, dataKey, displayLength)
  }

  const handleChangeLength = (dataKey) => {
    console.log('handleChangeLength dataKey', dataKey)

    const request = createRequest()

    setPage(1)
    setDisplayLength(dataKey)
    onSearch(request, 1, dataKey)
  }

  const handleSearch = () => {
    console.log('handleSearch')
    setPage(1)

    const request = createRequest()

    onSearch(request, 1, displayLength)
  }

  const handleCancel = () => {
    console.log('handleCancel')

    setSubProjectCode('')
    setSubProjectName('')
    setPage(1)

    onSearch({}, 1, displayLength)
  }

  return (
    <>
      {schema?.searchForm && (
        <>
          <Row style={{ marginBottom: 10 }}>
            {schema.searchForm.subProjectCode && (
              <>
                <Col lg={4} md={4} sm={24} xs={24}></Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                  {schema.searchForm.subProjectCode.label}
                  <Input
                    name={schema.searchForm.subProjectCode.name}
                    value={subProjectCode}
                    placeholder={'ระบุ' + schema.searchForm.subProjectCode.label}
                    onChange={(value) => {
                      setSubProjectCode(value)
                    }}
                  />
                </Col>
              </>
            )}

            {schema.searchForm.subProjectName && (
              <>
                <Col lg={8} md={8} sm={24} xs={24}>
                  {schema.searchForm.subProjectName.label}
                  <Input
                    name={schema.searchForm.subProjectName.name}
                    value={subProjectName}
                    placeholder={'ระบุ' + schema.searchForm.subProjectName.label}
                    onChange={(value) => {
                      setSubProjectName(value)
                    }}
                  />
                </Col>
                <Col lg={4} md={4} sm={24} xs={24}></Col>
              </>
            )}
          </Row>

          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={16} md={16} sm={24} xs={24}>
              <SearchButton disabled={loading} onClick={handleSearch}>
                ค้นหา
              </SearchButton>
              <CancelButton disabled={false} onClick={handleCancel}>
                ยกเลิก
              </CancelButton>
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>
        </>
      )}

      <Table wordWrap autoHeight loading={loading} data={tableData}>
        <Column width={70} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return (page - 1) * displayLength + index + 1
            }}
          </Cell>
        </Column>
        <Column width={150}>
          <HeaderCell>รหัสโครงการย่อย</HeaderCell>
          <Cell dataKey="subProjectCode" />
        </Column>

        <Column width={320} minWidth={320} flexGrow={1}>
          <HeaderCell>ชื่อโครงการย่อย</HeaderCell>
          <Cell dataKey="subProjectName" />
        </Column>

        <Column width={120}>
          <HeaderCell>จำนวนงวด</HeaderCell>
          <Cell dataKey="periodNum" />
        </Column>

        <Column width={180} align="right">
          <HeaderCell>งบอนุมัติ (บาท)</HeaderCell>
          {/* <Cell dataKey="budget" /> */}
          <Cell>
            {(rowData) => {
              return budgetFormat(rowData.budget || 0)
            }}
          </Cell>
        </Column>

        <Column width={110} align="center" fixed="right">
          <HeaderCell></HeaderCell>
          <Cell>
            {(rowData) => {
              return (
                <>
                  <ViewButton
                    icon="eye"
                    onClick={() => {
                      onSelect(rowData)
                    }}
                  >
                    แสดง
                  </ViewButton>
                </>
              )
            }}
          </Cell>
        </Column>
      </Table>

      <TablePagination
        lengthMenu={defaultLengthMenu}
        activePage={page || defaultPage}
        renderLengthMenu={(lengthMenu) => {
          return (
            <>
              {lengthMenu}
              {`รายการ/หน้า`}
            </>
          )
        }}
        renderTotal={(total) => {
          return <>{` ทั้งหมด ${total} รายการ`}</>
        }}
        displayLength={displayLength || 5}
        total={totalSize || 0}
        onChangePage={handleChangePage}
        onChangeLength={handleChangeLength}
      />
    </>
  )
}
